import {useState,useEffect} from 'react'


function Customers() {
    const [embedUrl, setEmbedUrl] = useState("");
    const [renderUrl, setRenderUrl] = useState("");



    useEffect(() => {
        
        fetch('/api/embed')
        .then(res => res.json())
        .then(url =>{
            console.log(decodeURI(url['value']['url']));
            setEmbedUrl(url['value']['url'])
        })

    },[])

    const changeIframeUrl = (name) => {
        console.log(name);
        let url = ""
        fetch('/api/embedDashboard',{
            method:"POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body:JSON.stringify({
                dashboard:name
            })     
        })
        .then(res => res.json())
        .then(url =>{
            console.log(decodeURI(url['value']['url']));
            setEmbedUrl(url['value']['url'])
        })
    }



  return (
    <>
    <button onClick={()=> changeIframeUrl("Sales Data")}>Sales Data</button>
    <button onClick={()=> changeIframeUrl("Sales Data 2")}>Sales Data 2</button>
    <button onClick={()=> changeIframeUrl("Test 2")}>Test</button>
        <iframe id="looker" width="1000" height="800" src={embedUrl} frameBorder="0">
        </iframe>
    </>
  );
}

export default Customers;